import { InnerContentWrap, useBreakpointV2 } from "@tm/ui-widgets";
import {
  FlexComp,
  FormattedText,
  H2Tag,
  H4Tag,
  H5Tag,
  ImageComponent,
  ParaTag,
  TextNodeType,
} from "@tm/ui-widgets/components";
import { usePartnerContext } from "@tm/ui-widgets/hooks";
import { theme } from "@tm/utility/global";
import { BenefitItem, WhatsCoveredStyle } from "./WhatsCovered.style";

interface WhatsCoveredProps {
  data?: {
    title: TextNodeType;
    info: TextNodeType;
    cardImg: string;
  }[];
  title?: TextNodeType;
  info?: TextNodeType;
}

const WhatsCovered = ({ data, title, info }: WhatsCoveredProps) => {
  const device = useBreakpointV2();
  const context = usePartnerContext();
  return (
    <WhatsCoveredStyle pageTheme={context ? context : undefined}>
      <InnerContentWrap>
        {device == "lg" ? (
          <H2Tag>{title && <FormattedText value={title} />}</H2Tag>
        ) : (
          <H5Tag>{title && <FormattedText value={title} />}</H5Tag>
        )}
        <ParaTag
          fontSize={device == "lg" ? "large" : "sm"}
          color={theme.greyText}
          margin="0 0 66px"
        >
          {info && <FormattedText value={info} />}
        </ParaTag>
        <FlexComp
          gap={device == "lg" ? (data?.length === 2 ? "50px" : "82px") : "24px"}
          padding="0 0 15px 0"
        >
          {data &&
            data.map((item, index) => {
              return (
                <BenefitItem key={index}>
                  {item.cardImg && (
                    <ImageComponent
                      width={device == "lg" ? "164px" : "80px"}
                      height={device == "lg" ? "164px" : "80px"}
                      src={item.cardImg}
                    />
                  )}
                  {device == "lg" ? (
                    <H4Tag margin="0 0 8px">
                      {item.title && <FormattedText value={item.title} />}
                    </H4Tag>
                  ) : (
                    <ParaTag
                      fontSize="large"
                      fontWeight="black"
                      margin="0 0 8px"
                    >
                      {" "}
                      {item.title && <FormattedText value={item.title} />}
                    </ParaTag>
                  )}
                  <ParaTag
                    fontSize={device == "lg" ? "large" : "sm"}
                    color={device == "lg" ? theme.greyText7 : theme.blackText}
                  >
                    {item.info && <FormattedText value={item.info} />}
                  </ParaTag>
                </BenefitItem>
              );
            })}
        </FlexComp>
      </InnerContentWrap>
    </WhatsCoveredStyle>
  );
};

export default WhatsCovered;
